import * as React from 'react';
export default function SvgTriangle() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.876 6.192L5.64 16.688A1.25 1.25 0 006.753 18.5h10.501a1.25 1.25 0 001.114-1.81L13.105 6.193a1.245 1.245 0 00-2.228 0zm3.57-.67c-1.013-2.025-3.898-2.025-4.911-.001L4.298 16.018C3.385 17.844 4.708 20 6.753 20h10.501c2.045 0 3.37-2.155 2.456-3.981L14.445 5.52z",
    fill: "currentColor"
  }));
}